/*
 * Module for an kbResponseType item
 */
define([
  "backbone",
  "underscore",
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbResponseTypeUsage/kbResponseTypeUsageView",
  "modules/accountAdmin/kbAdmin/kbModel",
], function (Backbone, _, Marionette, $, Messenger, KbResponseTypeUsageView, KbModel) {
  var KbResponseTypeUsageModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbResponseTypeUsageView";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },

    show: function (kb) {
      this.kb = kb;

      this.layout = new KbResponseTypeUsageView.kbResponseTypeUsageLayout({
        model: this.kb,
      });

      this.touchPoints = this.kb.getTouchPoints();
      this.languages = this.kb.getLocales();

      if (this.editMode) {
        this.touchPoints.fetch({ kbId: this.kb });
        this.kb.responseTypeCapacity = Messenger.reqres.request(
          "fetch:kbModel:responseTypeCapacity",
          this.kb.get("kbId"),
        );
      } else {
        this.kb.responseTypeCapacity = Messenger.reqres.request(
          "fetch:tenant:responseTypeCapacity",
          this.kb.get("tenantId"),
        );
      }

      this.kb.responseTypeCapacity.onSynced(function () {
        this.touchPoints.onSynced(function () {
          this.languages.onSynced(function () {
            this.languagesSize = this.languages.length;
            this.touchpointsSize = this.touchPoints.length;
            if (!this.editMode) {
              if (this.languagesSize == 0) {
                this.languagesSize = 1;
              }
              if (this.touchpointsSize == 0) {
                this.touchpointsSize = 1;
              }
            }
            this.updateUI();
          }, this);
        }, this);
      }, this);
    },

    responseTypeUsageValid: function () {
      var valid = true;
      if (
        this.kb.responseTypeCapacity.get("capacity") > 0 &&
        this.languagesSize &&
        this.touchpointsSize
      ) {
        valid =
          this.languagesSize * this.touchpointsSize <= this.kb.responseTypeCapacity.get("capacity");
      }
      return valid;
    },

    updateUI: function () {
      this.kb.responseTypesUsage = $.t("admin.kbAdmin.responseTypesUsed", {
        usage: this.languagesSize * this.touchpointsSize,
        capacity: this.kb.responseTypeCapacity.get("capacity"),
      });
      this.showRegion(this.layout);
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "fetch:kb:responseTypeUsage:language:change:decrease",
        function () {
          this.languagesSize = this.languagesSize - 1;
          this.updateUI();
        },
        this,
      );
      Messenger.vent.on(
        "fetch:kb:responseTypeUsage:language:change:increase",
        function () {
          this.languagesSize = this.languagesSize + 1;
          this.updateUI();
        },
        this,
      );
      Messenger.vent.on(
        "fetch:kb:responseTypeUsage:touchpoint:change:decrease",
        function () {
          this.touchpointsSize = this.touchpointsSize - 1;
          this.updateUI();
        },
        this,
      );
      Messenger.vent.on(
        "fetch:kb:responseTypeUsage:touchpoint:change:increase",
        function () {
          this.touchpointsSize = this.touchpointsSize + 1;
          this.updateUI();
        },
        this,
      );

      Messenger.reqres.setHandler(
        "fetch:kb:responseTypeUsage:valid",
        function () {
          return this.responseTypeUsageValid();
        },
        this,
      );
    },
  });

  return KbResponseTypeUsageModule;
});
